import { render, staticRenderFns } from "./forgotten-password.vue?vue&type=template&id=500d0d0f&"
import script from "./forgotten-password.vue?vue&type=script&lang=js&"
export * from "./forgotten-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports